import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import { useParams, Link } from "react-router-dom";
import axios from "axios/index";

import {ActivityStatusWithContent} from "../../pages/Lesson/Lesson.type";

import './styles.scss';
import {Listen} from "../Activities";
import {Choose} from "../Activities/Choose/Choose";
import {LEARN_ACTIVITIES} from "../../content/Topics/Land_Nature/learn_data";
import {PRACTICE_ACTIVITIES} from "../../content/Topics/Land_Nature/practice_data";
import {STORIES_ACTIVITIES} from "../../content/Topics/Land_Nature/stories_data";
import {TrueFalse} from "../Activities/TrueFalse";
import {MatchingPairs} from "../Activities/MatchingPairs/MatchingPairs";

export const Activity = ({
  data,
  type,
  activityType,
}: {
  // data: Array<ActivityStatusWithContent>
  data?: ActivityStatusWithContent,
  type: string,
  activityType?: string,
}) => {
  // console.log("data", data)
  const { activityId } = useParams();
  // const currentActivity = data?.find(item => item.id === activityId) || data[0];
  // console.log('currentActivity', currentActivity)
  // const [error, setError] = useState(null);
  //
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(`http://localhost:8000/activity`, {
  //         withCredentials: true,
  //       });
  //       const { activity } = response.data;
  //     } catch (err: any) {
  //       setError(err.response?.data?.message || err.message);
  //     }
  //   };
  //
  //     fetchData();
  // }, []);

  // console.log('activityId',activityId);
  // console.log('data', data)

  // if(!!currentActivity) return null;

  let ACTIVITIES: any = LEARN_ACTIVITIES;
  if (type === "practice") {
    ACTIVITIES = PRACTICE_ACTIVITIES;
  }
  if (type === "story") {
    ACTIVITIES = STORIES_ACTIVITIES;
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => setCurrentIndex(i => Math.max(i - 1, 0));
  const handleNext = () => setCurrentIndex(i => Math.min(i + 1, ACTIVITIES.length - 1));
  const currentItem = ACTIVITIES[currentIndex];
  const lastItemIndex = ACTIVITIES.length - 1;

  return (
    <div className={classNames("ActivityContainer", {
    })}>
      {type=== "learn" && currentItem.activity_type === "listen" &&
        <Listen
          images={[currentItem.image]} audio={currentItem.audio}
          controls={{ handlePrev: handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex }
        }/>
      }

      {type=== "practice" && currentItem.activity_type === "ChooseImage" &&
        <Choose type="Image"
          images={currentItem.image}
          audio={currentItem.audio}
          controls={{
          handlePrev: handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex }
        }
        />
      }

      {type=== "practice" && currentItem.activity_type === "ChooseAudio" &&
				<Choose type="Audio"
          images={currentItem.image}
          audio={currentItem.audio}
          controls={{
            handlePrev: handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex }
          }
				/>
      }

      {type=== "practice" && currentItem.activity_type === "TrueFalse" &&
				<TrueFalse
					images={currentItem.image}
					audio={currentItem.audio}
          answer={currentItem.answer}
					controls={{
            handlePrev: handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex
          }
          }/>
      }

      {type=== "story" && currentItem.activity_type === "ChooseImage" &&
        <Choose type="Image"
          images={currentItem.image}
          audio={currentItem.audio}
          controls={{
            handlePrev:handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex }
          }
			/>}

      {type=== "practice" && currentItem.activity_type === "MatchingPairs" &&
				<MatchingPairs
          images={currentItem.image}
          audio={currentItem.audio}
          controls={{
            handlePrev:handlePrev, handleNext: handleNext, currentIndex: currentIndex, lastItemIndex: lastItemIndex }
          }
				/>}
      {/*<Controls handlePrev={handlePrev} handleNext={handleNext} currentIndex={currentIndex} resetSelection={setResetSelection}/>*/}
      {/*<Listen images={["/units/land_nature/images/It's raining.png"]} audio="/units/land_nature/audio/Ki-mi-on.m4a" />*/}
      {/*<Choose type="Audio" images={[{path: "/units/land_nature/images/The wind is strong.png"}]} audio={[*/}
      {/*  {path: "/units/land_nature/audio/Mickwenowe (together).m4a",  correct: true},*/}
      {/*  {path: "/units/land_nature/audio/Sok-pin.m4a", correct: false}*/}
      {/*]}/>*/}
      {/*<Choose type="image" images={[*/}
      {/*  {path: "/units/land_nature/images/It's raining.png", correct: true},*/}
      {/*  {path: "/units/land_nature/images/cold.png"}]} audio={[*/}
      {/*  {path: "/units/land_nature/audio/Ki-si-na.m4a"}*/}
      {/*]}/>*/}
      {/*<Choose type="Image"*/}
      {/*  images={[*/}
      {/*    {path: "/units/land_nature/images/The snow is falling.png", correct: true},*/}
      {/*    {path: "/units/land_nature/images/The wind is strong.png", correct: false}]}*/}
      {/*  audio={[{path: "/units/land_nature/audio/Sokpin together.m4a"}]}/>*/}
    </div>
  );
};
